var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.show
    ? _c("div", { staticClass: "incomplete-viewing-msg" }, [
        _c(
          "a",
          {
            staticClass: "modal-box",
            attrs: { href: _vm.holder_path + "#auto_play" }
          },
          [
            _c("div", { staticClass: "close", on: { click: _vm.close } }, [
              _c("img", {
                attrs: {
                  src:
                    "https://enklav-production.s3.amazonaws.com/uploads/image/x-20x20-white.svg"
                }
              })
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "m-header bold" }, [
              _vm.poster
                ? _c("img", {
                    staticClass: "poster",
                    attrs: { src: _vm.poster }
                  })
                : _vm._e(),
              _vm._v(" "),
              _c("p", [
                _vm._v(
                  "Ready to " +
                    _vm._s(_vm.is_audio ? "listen" : "watch") +
                    ' "' +
                    _vm._s(_vm.holder.title) +
                    '" again?'
                )
              ])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "m-body" }, [
              _vm._v(
                "\n            You don't want to miss the ending! Don't forget to " +
                  _vm._s(_vm.is_audio ? "listen to" : "watch") +
                  " the rest of your " +
                  _vm._s(_vm.is_audio ? "podcast" : "video") +
                  "\n        "
              )
            ])
          ]
        )
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }